import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseResponse } from '../models/base-response.model';
import { SearchTableParam } from '../models/base-search.model';
import { TheUserSearch, TheUserSubscrbtionSearch, User, UserGetAllResponse, UserListRespone, UserResponse, UserSearch } from './models/data-models';
import { ToastrService } from 'ngx-toastr';


@Injectable({
  providedIn: 'root'
})
export class UserApiService {

  constructor(private http: HttpClient,  private snotifyService: ToastrService,
  ) { }

  public create(request: User) {
    return this.http.post<BaseResponse<number>>("/users/Create", request);
  }
  public update(request: User) {
    return this.http.post<BaseResponse<number>>("/Users/Update", request);
  }
  public getList(request: SearchTableParam<UserSearch>, sortType?: number) {
    if (sortType) {
      return this.http.post<UserListRespone>("/Users/GetList", request, { params: { fillterType: sortType.toString() } });
    }
    else {
      return this.http.post<UserListRespone>("/Users/GetList", request);
    }
  }


  public GetListWithAdvanceSearcht(request: SearchTableParam<TheUserSubscrbtionSearch>, sortType?: number) {
    if (sortType) {
      return this.http.post<UserListRespone>("/users/GetListWithAdvanceSearch", request, { params: { fillterType: sortType.toString() } });
    }
    else {
      return this.http.post<UserListRespone>("/users/GetListWithAdvanceSearch", request);
    }
  }

  public ThegetList(request: SearchTableParam<TheUserSearch>, sortType?: number) {
    if (sortType) {
      return this.http.post<UserListRespone>("/Users/GetList", request, { params: { fillterType: sortType.toString() } });
    }
    else {
      return this.http.post<UserListRespone>("/Users/GetList", request);
    }
  }
  public getCustomerGroups() {
    return this.http.get<any>("/customergroups");
  }
  public deleteCustomerGroupsById(id) {
    return this.http.delete<any>(`/customergroups/${id}`);
  }
  public getCustomerGroupsById(id) {
    return this.http.get<any>(`/customergroups/${id}`);
  }
  public editCustomergroups( value) {
    return this.http.post(`/customergroups/Upsert`, value)
  }
  public getRoles() {
    return this.http.get("/RolesManagement/GetRoles");
  }

  public get(id: number) {
    return this.http.get<BaseResponse<UserResponse>>(`/Users/GetUser?Id=${id}`);
  }
  public delete(id: number) {
    return this.http.delete<BaseResponse<number>>(`/Users/deleteUser/${id}`);
  }
  public getAll() {
    return this.http.get<UserGetAllResponse[]>(`/Users/GetAll`);
  }

  public syncADUsers() {
    return this.http.get<any>(`/Users/SyncADUsers`);
  }
  public getWorkingHoursList(value) {
    return this.http.post(`/admin/WorkingHours/GetAllWorkingHourse`, value)
  }
  public getWorkingHoursById(id: number) {
    return this.http.get(`/admin/WorkingHours/GetById/${id}`)
  }
  public upsertWorkingHours(value) {
    return this.http.post(`/admin/WorkingHours/upsertWorkingHours`, value)
  }
  public addCustomergroups(value) {
    return this.http.post(`/customergroups/Upsert`, value)

  }
  importExcel(file: File, group, role) {
    const formData: FormData = new FormData();
    const fileToUpload = file as File;
    formData.append("formFile", fileToUpload);

    return this.http.post(
      `/users/UploadUsers?RoleId=${role}&CustomerGroupId=${group}`,
      formData
    );
  }


  public removeWokingHousr(id: number) {
    return this.http.delete(`/admin/WorkingHours/Remove/${id}`)
  }
  public getALLLoggedInUser(value) {
    return this.http.post(`/LoggedInUser/GetAll`, value)
  }
  public changedLookedOutStatus(id: number, lookedOut: boolean) {
    return this.http.patch(`/LoggedInUser/ChangeLookedOutUserStatus/${id}/${lookedOut}`, {})
  }
  public getUserLoginTransactions(value) {
    return this.http.post(`/admin/GetUserLoginTransactions`, value)
  }
  public getchangeHistory(userId) {
    return this.http.get(`/admin/GetPasswordHistory/${userId}`)
  }
  public killSession(id) {
    return this.http.post(`/LoggedInUser/KillSessionsOnCurrentUser/${id}`, {})
  }

  exportUsers(params) {

    var httpPromise = this.http.post("/users/ExportUsersData", params, { responseType: 'blob' });

    httpPromise.subscribe(function (response) {
      var blob = new Blob([response], { type: "text/xlsx" });
      // this.getBlob(blob, "orders-export.csv");
      var filename = "UsersFile.xlsx";
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      }
      else {
        var objectUrl = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = objectUrl;
        // a.style = "display: none";
        a.download = filename; // gives it a name via an a tag
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(objectUrl);
        document.body.removeChild(a);
      }

    });
  }


  public addCustomerGroupType(data: any) {
    return this.http.post(`/CustomerGroupType/Create`, data)
  }


  public getGroupTypeById(id: any) {
    return this.http.post(`/CustomerGroupType/Details/${id}`, { groupTypeId: id })
  }

  public editGroupType(data: any) {
    return this.http.post('/CustomerGroupType/Update', data)
  }
  public getAllUserGroupTypes(prams: any) {
    return this.http.post(`/CustomerGroupType/GetGroupTypes`, prams)
  }


  public deleteUserGroupType(id: any) {
    return this.http.post(`/CustomerGroupType/Delete/${id}`, { groupTypeId: id })
  }


  public unPublishUserGroupType(id: any) {
    return this.http.post(`/CustomerGroupType/UnPublish/${id}`, { groupTypeId: id })
  }

  public publishUserGroupType(id: any) {
    return this.http.post(`/CustomerGroupType/Publish/${id}`, { groupTypeId: id })
  }

  public getUserOptionKeys() {

    return this.http.get(`/Account/GetUserOptionKeys`)
  }





  addUserQuery(body: any) {

    return this.http.post(`/search/AddUserQuery`, body)
  }


  getUSerQueries(body: any) {
    return this.http.post('/search/GetUserQueries', body)
  }



  deleteUserQuery(id, body: any) {
    let pram = { body: body }
    return this.http.post(`/search/DeleteUserQuery/${id}`, pram)
  }





  openNotifyError(message: string) {
    this.snotifyService.error(message, "", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifySuccess(message: any) {
    this.snotifyService.success(message, "", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

}
